import React from 'react'
import { Modal } from 'react-bootstrap'
const ContactDetail = (props) => {
  const closeModal = () => {
    props.onCloseModal(true)
  }
  return (
    <Modal
      show={props.props.IsShowModal}
      onHide={closeModal}
      keyboard={true}
    >
      <Modal.Header>
        <div>
          <h6>Contact Detail</h6>
        </div>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={closeModal}
        >
          <i
            className="fa fa-times"
            aria-hidden="true"
          ></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 stretch-card">
              <div className="card">
                <div className="card-body">
                  <div className="row justify-content-between">
                    <div className="col-md-12">
                      <div className="card-header p-0 mb-3"></div>
                    </div>
                    <div className="col-md-12">
                      <div className="address-info">
                        <table className="table table-striped table-borderless table-diamond-detail">
                          <tbody>
                            <tr key={Math.random()}>
                              <td className="text-black ">Name</td>
                              <td>{props.props.data.name}</td>
                            </tr>
                            <tr key={Math.random()}>
                              <td className="text-black">Email</td>
                              <td>{props.props.data.email}</td>
                            </tr>
                            {props.props.data.phone !== '' && props.props.data.phone !== null && (
                              <tr key={Math.random()}>
                                <td className="text-black">Phone</td>
                                <td>{props.props.data.phone}</td>
                              </tr>
                            )}
                            <tr key={Math.random()}>
                              <td className="text-black">Message</td>
                              <td>{props.props.data.message}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ContactDetail
